import ClubCrownIcon from "../../../components/Icon/ClubCrownIcon";
import ClubLateIcon from "../../../components/Icon/ClubLateIcon";
import ClubPendingIcon from "../../../components/Icon/ClubPendingIcon";

// Selo do clube na primeira coluna: é a informação que muda a conduta do
// atendimento. Usa a mesma coroa da agenda e do histórico para o operador não
// precisar aprender um símbolo novo. O campo vem pronto em CustomerResource.clubMember.
//
// Ser do clube e estar em dia são coisas diferentes: quem atrasa continua sendo do clube
// (mantém a coroa) e ganha o alerta de mensalidade em atraso ao lado, exatamente como já
// acontece na agenda, no histórico de atendimento e na venda.
const clubRenderer = (params) => {
	const isMember = params.value === true || params.value === 'true';
	const isLate = params.data?.clubLate === true || params.data?.clubLate === 'true';
	const isPending = params.data?.clubPendingFirstPayment === true
		|| params.data?.clubPendingFirstPayment === 'true';
	const planName = params.data?.clubPlanName;

	if (!isMember) {
		return null;
	}

	// Contrato sem nenhum pagamento: coroa apagada, para não prometer no balcão um
	// benefício que o cliente ainda não tem. O desconto só começa no primeiro pagamento.
	if (isPending) {
		const pendingTitle = planName
			? `Plano do Clube: ${planName} (aguardando o primeiro pagamento, sem benefício)`
			: 'Clube aguardando o primeiro pagamento (sem benefício)';

		return (
			<>
				<ClubCrownIcon className="text-secondary" title={pendingTitle} />
				<ClubPendingIcon title={pendingTitle} />
			</>
		);
	}

	if (isLate) {
		const lateTitle = planName
			? `Plano do Clube: ${planName} (mensalidade em atraso)`
			: 'Clube com mensalidade em atraso';

		// className explícito nos dois ramos: o default do ícone traz ms-1, pensado para
		// quando ele aparece depois do nome. Aqui a coroa é o primeiro elemento da célula
		// e precisa encostar na margem, senão as linhas em atraso saem desalinhadas das
		// linhas em dia. O ms-1 fica só no alerta, que vem em segundo.
		return (
			<>
				<ClubCrownIcon className="text-warning" title={lateTitle} />
				<ClubLateIcon title={lateTitle} />
			</>
		);
	}

	return (
		<ClubCrownIcon
			className="text-warning"
			title={planName ? `Plano do Clube: ${planName}` : 'Membro do Clube'}
		/>
	);
};

// Colunas do grid.
export const Columns = [
	{
		headerName: 'club',
		field: 'clubMember',
		width: 90,
		cellRenderer: clubRenderer,
		// Alinhado à esquerda como as demais colunas. Centralizado, o selo dançava na
		// horizontal conforme a linha tivesse um ícone (coroa) ou dois (coroa + atraso).
		cellStyle: { textAlign: 'left' },
		// Não é atributo de Customer, então ordenar por ele quebraria a consulta.
		sortable: false
	},
	{
		headerName: 'name',
		field: 'fullName',
		// Largura maior que o padrão do grid: nome completo com sobrenome composto
		// vinha cortado, e é o dado que identifica a linha.
		width: 320,
		filter: true
	},
	{
		headerName: 'phone',
		field: 'phone',
		filter: true,
		width: 150
	},
	{
		headerName: 'cpf',
		field: 'document',
		filter: true,
		width: 150
	},
	{
		headerName: 'email',
		field: 'email',
		filter: true,
		width: 200
	},
	{
		headerName: 'Cadastrado em',
		field: 'branch.name',
		filter: true,
		width: 180
	},
	{
		headerName: 'birthDate',
		field: 'birthDate',
		type: 'date'
	},
	{
		headerName: 'gender',
		field: 'gender',
		width: 120
	},
	{
		headerName: 'status',
		field: 'status',
		type: 'trans',
		with: 130
	}
]
